// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = obj => {
  if (obj === undefined || obj === null) return true
  else return Object.keys(obj).length === 0
}

// ** Checks if an object is empty (returns boolean)
export const isNumberEmpty = obj => {
  if (obj === undefined || obj === null) return true
  else return !(Number(obj) > 0)
}


/**
 * 숫자 표시 (콤마를 표시해줌)
 * num : 변환할 숫자
 * zeroYn : 값이 0일 경우 0 표시 여부 (Y/N)
 */
export const convertNumberFormat = (num, zeroYn) => {
  if (zeroYn === 'Y') {
    if (isNumberEmpty(num)) {
      return '0';
    } 
  } else {
    if (isObjEmpty(num)) {
      return '';
    } 
  }

  return num.toString().replace(/[^\d]+/g, '').replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
}

/**
 * 휴대폰번호 포맷
 */
export const convertPhoneNumberFormat = (num) => {
  if (isObjEmpty(num)) {
    return ''
  } else {
    return num.replace(/[^0-9]/, '').replace(/^(\d{3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  }
}

/**
 * 날짜와 시간 formatting 
 * MM월 DD일(W) HH:MM
 */
export const convertDateTime = (date, yearYn='N') => {
  if (date !== undefined && date !== null && !isObjEmpty(date)) {
    const dY = date.slice(0, 4);
    const dM = date.slice(4, 6);
    const dD = date.slice(6, 8);
    const tH = date.slice(8, 10);
    const tM = date.slice(10, 12);
    const stringYMD = `${dY}-${dM}-${dD}`;

    let week = new Array('일', '월', '화', '수', '목', '금', '토');
    let today = new Date(stringYMD).getDay();
    let todayLabel = week[today];

    let stringDate = '';
    if (yearYn === 'Y') {
      stringDate = `${dY}년 ${dM}월${dD}일(${todayLabel}) ${tH}:${tM}`;
    } else {
      stringDate = `${dM}월${dD}일(${todayLabel}) ${tH}:${tM}`;
    }

    return stringDate;
  } else {
    return ''
  }
}

/**
 * 촬영일자 날짜 및 시간 formatting
 * YYYY년 MM월 DD일(W) HH:MM or YYYY년 MM월 DD일 시간 미정
 */
export const convertDateTimeForSending = (date) => {
  if (date !== undefined && date !== null && !isObjEmpty(date)) {
    const dY = date.slice(0, 4);
    const dM = date.slice(4, 6);
    const dD = date.slice(6, 8);
    const tH = date.slice(8, 10);
    const tM = date.slice(10, 12);
    const stringYMD = `${dY}-${dM}-${dD}`;

    let week = new Array('일', '월', '화', '수', '목', '금', '토');
    let today = new Date(stringYMD).getDay();
    let todayLabel = week[today];
    let time = `${tH}:${tM}`;
    if (tH === '00' && tM === '00') {
      time = '시간 미정';
    }

    const stringDate = `${dY}년 ${dM}월${dD}일(${todayLabel}) ${time}`; 
    return stringDate;
  } else {
    return ''
  }
}

/**
 * 날짜 formatting
 */
export const convertDate = (date) => {
  if (date !== undefined && date !== null && !isObjEmpty(date)) {
    const dY = date.slice(0, 4);
    const dM = date.slice(4, 6);
    const dD = date.slice(6, 8);
    const stringYMD = `${dY}.${dM}.${dD}`;

    return stringYMD;
  } else {
    return ''
  }
} 

/** 
 * 날짜 형식 두 자리수 formatting
 * desc 날짜가 한 자리일 경우 두 자리로 표현
 */
export const digitFormatting = (number) => {
  if(parseInt(number) < 10){
    let result = '0' + number;
    return result;
  } else{
    return number;
  }
}

/**
 * 날짜 slice 
 * @param {string} date 날짜 YYYYMMDDHHMM
 * @returns {string} yyyyMMDD
 */
export const dateSlice = (date) => {
  const dY = date.slice(0, 4);
  const dM = date.slice(4, 6);
  const dD = date.slice(6, 8);
  const str = `${dY}${dM}${dD}`;

  return str;
}

/**
 * 환불을 위한 날짜 비교
 * @param {string} date YYYYMMDDHHMM
 * @param {string} today YYYYMMDDHHMM
 */
export const compareRefundDate = (date, today) => {
  let refundState = '';
  if (date !== undefined && date !== null && !isObjEmpty(date)) {
    const strDate = dateSlice(date);
    const strToday = dateSlice(today);

    if (parseInt(date) < parseInt(today)) {
      refundState = 'noRefund';
    } else if (parseInt(strDate) === parseInt(strToday)) { 
      refundState = 'refundWithPenalty';
    } else {
      refundState = 'fullRefund';
    }
  }

  return refundState;
}

/**
 * 날짜 포맷변경하기
 */
export const convertDateFormat = (date) => {
  if (date !== undefined && date !== null && !isObjEmpty(date)) {
    let year = date.slice(6,10);
    let month = date.slice(0,2);
    let day = date.slice(3,5);

    const stringYMD = year + month + day;

    return stringYMD;
  } else {
    return ''
  }
}

/**
 * 마스킹 처리
 * @param {string} string 변환할 string
 */
export const convertMaskingString = (string) => {
  let maskingStr = '';
  let mask = '';
  // maskingStr = string.replace(/(?<=.{1})./gi, "*"); // safari 호환 문제로 사용 불가

  if (!isObjEmpty(string)) {
    if (string.length > 2) {
      maskingStr = string.substring(0, 1);
      [...Array(string.length - 1)].map( i => {
        maskingStr += '*';
      });
    } else { // 외자일 경우
      maskingStr = string.substring(0, 1) + '*';      
    }
  }

  return maskingStr;
}

/**
 * @returns YYYYMMDDHHSS 형식의 오늘 날짜
 */
export const todayDateTime = () => {
  const date = new Date();
  const year = date.getFullYear().toString();

  let month = date.getMonth() + 1;
  month = month < 10 ? '0' + month.toString() : month.toString();
  
  let day = date.getDate();
  day = day < 10 ? '0' + day.toString() : day.toString();
  
  let hour = date.getHours();
  hour = hour < 10 ? '0' + hour.toString() : hour.toString();

  let minute = date.getHours();
  minute = minute < 10 ? '0' + minute.toString() : minute.toString();

  return year + month + day + hour + minute;
}